import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesIndividual',
    label: 'Outcomes Individual Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
